module.exports = __webpack_public_path__ + "img/inventoryStorage.b5547e31.png";